import { Stack } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { getPosts } from "../api/posts";
import { isLoggedIn } from "../helpers/authHelper";
import FindUsers from "./FindUsers";
import ExploreTopics from "./ExploreTopics";
import WelcomeBanner from "./WelcomeBanner";
// import Footer from "./Footer";
import Loading from "./Loading";
import PostCard from "./PostCard";
import TopPosts from "./TopPosts";

const Sidebar = () => {
  const user = isLoggedIn();
  
  return (
    <Stack spacing={3}>
      <TopPosts />
      <ExploreTopics />
      <FindUsers />
      {/* Only show WelcomeBanner when logged in (it will be shown at top when not logged in) */}
      {/* {user && <WelcomeBanner />} */}
      {/* <Footer /> */}
    </Stack>
  );
};

export default Sidebar;
